import { EMPTY_VALUE } from "Common/componentUtils/constants";
import React, { memo } from "react";
import locale from "./edgeAttributes.locale";
function EdgeAttributes(props) {
    var _a;
    return (React.createElement("div", { className: props.className },
        React.createElement("div", null,
            React.createElement("div", { className: "text-lighton-surface-variant font-small" }, locale.METHOD),
            React.createElement("div", { className: "text-lighton-surface font-base font-bolder text-overflow-ellipsis" }, ((_a = props.data) === null || _a === void 0 ? void 0 : _a.MethodName) || EMPTY_VALUE))));
}
export default memo(EdgeAttributes);
